import { fallRiverConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function FallRiverPage() {
  return <CityPageTemplate config={fallRiverConfig} />;
}